import type { ComponentType } from 'react';
import type { SectionProps } from '@/types';
import { HeroSection } from './sections/HeroSection';
import { AboutSection } from './sections/AboutSection';
import { ProductsSection } from './sections/ProductsSection';
import { GallerySection } from './sections/GallerySection';
import { MapSection } from './sections/MapSection';
import { QrSection } from './sections/QrSection';
import { FeedbackSection } from './sections/FeedbackSection';
import { LeadFormSection } from './sections/LeadFormSection';
import { CustomHtmlSection } from './sections/CustomHtmlSection';

export const SECTION_REGISTRY: Record<string, ComponentType<SectionProps>> = {
  hero: HeroSection,
  about: AboutSection,
  products: ProductsSection,
  gallery: GallerySection,
  map: MapSection,
  qr: QrSection,
  feedback: FeedbackSection,
  leads: LeadFormSection,
  lead: LeadFormSection,
  custom_html: CustomHtmlSection,
};
